import React, {Component} from "react";
import Dropzone from "react-dropzone";
import Modal from "./Modal";
import PreloadingMask from "./PreloadingMask";
import PartyTagModal from "./PartyTagModal";
import {checkMaxFileSize} from "./Helpers";
import {Button, Icon, Modal as alertModal} from "antd";
import {urlPath} from "./Settings";
import { getAuthHeader } from '../utils/security';

/*eslint no-loop-func: "off"*/
class DropArea extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alertModalContent: null,
			files: [],
			columns: [
				{
					title: "File Name",
					dataIndex: "name",
					width: 150
				},
				{
					title: "Size",
					dataIndex: "formatSize",
					width: 150
				},
				{
					title: "Type",
					dataIndex: "type",
					width: 150
				}
			],
			printAd: null
		};
	}

	error() {
		alertModal.error({
			title: this.props.translations.invalidFileType,
			content: this.state.alertModalContent
		});
	}

	selectedRowKeys = keys => {
		console.log(keys);
		this.setState({selectedRowKeys: keys});

		const {uploadFiles} = this.state;
		const uploadFilesTmp = uploadFiles;
		const uploadFilesTmpEnd = [];
		for(let value in keys) {
			for(let file in uploadFiles)
				if (uploadFiles[file].key === keys[value]) {
					//uploadFilesTmp.splice(file, 1);
					uploadFilesTmpEnd.push(uploadFilesTmp[file]);
					this.setState({uploadFilesTmpEnd: uploadFilesTmpEnd});
				}
		}
		return keys;
	};

	onDrop(files, rejected, evt) {
		let items = evt.dataTransfer? evt.dataTransfer.items: null;
		let reading = 0,
			reading2 = 0;
		var sizes = ["Bytes", "KB", "MB", "GB", "TB"];

		function scanFiles(entry) {
			console.log("Nested ", entry);
			reading2++;
			if (entry.isFile)
				entry.file(
					file => {
						file.fullPath = entry.fullPath;
						files.push(file);
						reading2--;
					},
					error => {
						console.error("Cannot convert to file", entry);
						reading2--;
					}
				);
			else {
				reading2--;
				let directoryReader = entry.createReader();
				directoryReader.readEntries(function(entries) {
					entries.forEach(entry => scanFiles(entry));
				});
			}
		}

		for(let index = 0; index < files.length; index++) {
			const file = files[index];
			const bytes = file.size;
			if (bytes === 0) {
				files.splice(index, 1);
				continue;
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
			file.formatSize = Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
			file.key = index;
			if (items && items[index].webkitGetAsEntry) {
				const item = items[index].webkitGetAsEntry();
				if (item && item.isDirectory) {
					files.splice(index, 1);
					reading++;
					item.createReader().readEntries(function(entries) {
						entries.forEach(function(entry) {
							scanFiles(entry);
						});
						reading--;
					});
				}
			}
		}
		const continueUpload = this.uploadFiles;
		if (reading === 0) continueUpload(files);
		else {
			function checkDone() {
				if (reading > 0 || reading2 > 0) window.setTimeout(checkDone, 100);
				else {
					if (files.length === 0) console.log("No files to upload");
					else continueUpload(files);
				}
			}

			checkDone();
		}
	}

	uploadFiles = files => {
		console.log("FilesFinal", files);
		this.props.printAd === "DIGITAL"
			? this.setState({alertModalContent: this.props.translations.validFileTypes + ": digital"})
			: this.setState({alertModalContent: this.props.translations.validFileTypes + ": pdf"});
		this.setState({printAd: this.props.printAd}, function() {
			if (
				(this.state.printAd === "PRINTED" || this.state.printAd === "NORMAL") && files[0].type === "application/pdf" /* || files[0].type === "application/postscript" */) {
				this.setState({
					tableData: files,
					uploadFiles: files,
					files
				});
				setTimeout(() => files.length === 1? this.handleOk(): this.setState({visible: true}), 100);
			} else if (this.state.printAd === "DIGITAL") {
				this.setState({
					tableData: files,
					uploadFiles: files,
					files
				});
				setTimeout(() => files.length === 1? this.handleOk(): this.setState({visible: true}), 100);
			} else this.error();
		});
	};

	handleOk = () => {
		const {loadConfig, translations} = this.props;
		let maxSize = loadConfig["web.uploadadmaterial.maxsize"];
		const upload = checkMaxFileSize(this.state.uploadFiles, maxSize);
		if (upload) {
			this.setState({visible: false});
			this.props.submitting();
			const formData = new FormData();
			const matspecId = this.props.materialSpecificationId;
			const admaterialId = this.props.specId;
			formData.append("matspec", matspecId);
			if (admaterialId > 0) formData.append("admaterial", admaterialId);
			formData.append("thumbnailsize", 50);
			const uploadFiles = this.state.uploadFiles;
			let folderUpload = 0;
			for(let i = 0; i < uploadFiles.length; i++) {
				formData.append("files[]", uploadFiles[i]);
				folderUpload += uploadFiles[i].fullPath? uploadFiles[i].fullPath.length: 0;
			}
			console.log("FILES3", folderUpload, uploadFiles);
			if (folderUpload) {
				formData.append("folder", uploadFiles[0].fullPath.substring(1, uploadFiles[0].fullPath.indexOf("/", 2)));
				let paths = "";
				for(let i = 0; i < uploadFiles.length; i++)
					paths += "," + uploadFiles[i].fullPath.substring(1);
				formData.append("paths", paths.substring(1));
			}
			formData.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone)
			const xhr = new XMLHttpRequest();
			xhr.open("POST", urlPath + "/api/upload");
			xhr.setRequestHeader('Authorization', getAuthHeader().Authorization);
			xhr.withCredentials = true;
			xhr.onloadstart = ev => {
				this.props.admaterialUploading(matspecId, admaterialId);
				this.setState({processing: true});
			};
			xhr.onloadend = ev => {
				this.props.admaterialUploaded(JSON.parse(ev.currentTarget.response), matspecId, admaterialId);
				this.setState({processing: false});
			};
			xhr.send(formData);
		} else {
			alertModal.error({
				title: "Error",
				content: translations.fileSizeExceeded + ": " + maxSize + " MB"
			});
		}
	};
	handleCancel = ev => {
		console.log("closing modal", ev);
		this.setState({
			visible: false,
			tableData: [],
			className: "ix-creative-dropzone",
			files: []
		});
	};

	componentWillReceiveProps() {
		this.setState({processingPartyTag: this.props.processingPartyTag});
		setTimeout(() => !this.isCancelled && this.setState({strings: this.props.language}), 100);
	}

	render() {
		const {translations} = this.props;
		const creativeTypeVideo = this.props.record.creativetype && this.props.record.creativetype.toLowerCase() == "video";
		//const hasMaterial = this.props.record.original && this.props.record.original[0] && this.props.record.original[0].url;
		//if(!hasMaterial || devMode/*&& this.props.record.actions.UPLOAD_ADMATERIAL*/)
		return (
			<div className="droparea-container">
				<PreloadingMask
					text={translations.processing}
					visible={this.state.processing}
				/>
				<span
					className={this.props.record.dummyCreativeTypePrinted? "droparea-dropzone-container droparea-dropzone-container-big": "droparea-dropzone-container"}
					data-id={this.props.specId}
				>
          <div className="droparea">
            <form encType="multipart/form-data" action="">
              <Dropzone
	              className="droparea-dropzone"
	              onDrop={this.onDrop.bind(this)}
              >
                <div className="droparea-icons">
                  {this.props.record.dummyCreativeTypePrinted && (
	                  <Icon type="file-pdf"/>
                  )}
	                {!this.props.record.dummyCreativeTypePrinted &&
	                !creativeTypeVideo && (
		                <span>
                        <Icon type="picture"/>
                        <Icon type="play-circle"/>
                        <Icon type="html5"/>
                      </span>
	                )}
	                {!this.props.record.dummyCreativeTypePrinted &&
	                creativeTypeVideo && (
		                <span>
                        <Icon type="play-circle"/>
                      </span>
	                )}
                </div>
                <span className="droparea-text">
                  {translations.dropAreaText}
                </span>
                <span>{translations.or}</span>
                <Button type="primary">{translations.browse}</Button>
              </Dropzone>
            </form>
          </div>
        </span>
				{!this.props.record.dummyCreativeTypePrinted && (
					<div className="partytag-box">
						<p className="partytag-box-title">
							{translations.partyTagBoxTitle}
						</p>
						<ul className="partytag-box-list">
							<li>{translations.partyTags}</li>
							<li>{translations.trackings}</li>
							<li>{translations.instructions}</li>
							<li>{translations.sgCode}</li>
						</ul>
						<div className="partytag-box-button">
							<PartyTagModal
								saveFields={this.props.saveFields}
								id={this.props.record.id}
								pixeltracker={this.props.record.pixeltracker? this.props.record.pixeltracker: ""}
								description={this.props.record.description? this.props.record.description: ""}
								sgcode={this.props.record.sgcode? this.props.record.sgcode: ""}
								userurls={this.props.record.userurls? this.props.record.userurls: []}
								internal={this.props.internal}
								userurl={this.props.record.userurls && this.props.record.userurls[0]? this.props.record.userurls[0]: ""}
								handlePartyTag={this.props.handlePartyTag}
								loadConfig={this.props.loadConfig}
								materialSpecificationId={this.props.record.materialSpecificationId}
								placeholder={this.props.translations? this.props.translations.partytag: "script tag"}
								translations={this.props.translations}
								updateBooking={this.props.updateBooking}
							/>
						</div>
					</div>
				)}
				<Modal
					translations={this.state.translations}
					selectedRowKeys={this.selectedRowKeys}
					modalTitle={this.props.translations.uploadingFiles}
					tableData={this.state.files}
					columns={this.state.columns}
					visible={this.state.visible}
					onOk={this.handleOk}
					onReturn={this.handleCancel}
					onCancel={() => console.log("none")}
					preview={this.state.preview}
					onDelete={this.handleDelete}
				/>
			</div>
		);
		//else return null;
	}
}

export default DropArea;



// WEBPACK FOOTER //
// ./src/components/DropArea.js